import type { ReportLayoutWidget } from "@/app/app/_/views/ReportsView/ReportsView.utils";
import {
  PRESENTATION_LABELS,
  widgetDisplayTitle,
  type PresentationKind,
} from "@/app/app/_/views/ReportsView/ReportsView.utils";
import type { SharedViewWidgetShell } from "@/app/share/report/sharedReportTypes";

/** What a widget is called: its own title, else what it is of and how it is drawn. */
export function sharedReportWidgetDisplayTitle(
  apiWidget: SharedViewWidgetShell | undefined,
  reportLayoutWidget: ReportLayoutWidget | undefined,
  fallbackId?: string,
): string {
  if (apiWidget?.title?.trim()) {
    return apiWidget.title.trim();
  }
  if (reportLayoutWidget) {
    return widgetDisplayTitle(reportLayoutWidget);
  }
  if (apiWidget?.source) {
    const source = apiWidget.source.replace(/_/g, " ").replace(/^./, (first) => first.toUpperCase());
    const presentation = apiWidget.presentation
      ? (PRESENTATION_LABELS[apiWidget.presentation as PresentationKind] ?? apiWidget.presentation)
      : null;
    if (!presentation || presentation === "Table" || presentation === source) {
      return source;
    }
    return `${source} · ${presentation}`;
  }
  return fallbackId ?? "Widget";
}
